import { Box, Flex } from '@chakra-ui/react'
import React from 'react'
import { Helmet } from 'react-helmet'
import { useTranslation } from 'react-i18next'
import { useIamStore } from 'src/modules/iam/apis/store'
import CtaRegisterImage from 'src/modules/iam/components/CtaRegisterImage'
import LogInContainer from 'src/modules/iam/components/LogInContainer'
import { useRedirectSSO } from 'src/modules/iam/hooks/useRedirectSSO'
import '../../services/i18n/i18n'
import LeftIllustration from './components/LeftIllustration'

const Login: React.FC = () => {
  const [t] = useTranslation()

  const { state } = useIamStore((store) => ({ email: store.userEmail, state: store.state }))
  useRedirectSSO()

  return (
    <Flex
      background='primaryColors.400'
      flexDirection={['column', 'column', 'column', 'row', 'row']}
      justifyContent='space-between'
      w='100%'
      minHeight='100vh'
      overflowX='hidden'
    >
      <Helmet>
        <title>{t('login.Login')} | Education Journey</title>
      </Helmet>
      {!state('REGISTER.CTA_EXTENSION') && (
        <Flex flexDirection='column' paddingRight='0' flex='1' width={{ base: '100%', lg: '50%' }}>
          {state('VERIFY_EMAIL') ? (
            <Box>
              <LeftIllustration />
            </Box>
          ) : undefined}
          {state('USER_CREDENTIALS') ? (
            <Box>
              <LeftIllustration />
            </Box>
          ) : undefined}
          {state('CONFIRM_EMAIL_VERIFICATION') ? (
            <Box>
              <LeftIllustration />
            </Box>
          ) : undefined}
          {state('REGISTER_NEW_PASSWORD') ? (
            <Box>
              <LeftIllustration />
            </Box>
          ) : undefined}
          {state('REGISTER.CTA_REGISTER') ? <CtaRegisterImage /> : undefined}
          {state('REGISTER.REGISTER_FORM') ? <CtaRegisterImage /> : undefined}
          {state('REGISTER.VERIFY_EMAIL') ? <CtaRegisterImage /> : undefined}
        </Flex>
      )}
      <Flex
        flexDirection='column'
        alignItems='center'
        justifyContent='center'
        paddingRight='0'
        flex='1'
        width={{ base: '100%', lg: '50%' }}
        overflowY='auto'
        bg='white'
        borderTopRadius={{ base: 30, lg: 0 }}
      >
        <Flex flexDirection='column' width='100%' flex='1' alignItems='center' justifyContent='center'>
          <LogInContainer />
        </Flex>
      </Flex>
    </Flex>
  )
}

export default Login
